import React from "react";
import { Swiper } from "swiper/react";

const CreatorVideoSkeleton = () => {
  const arr = [1, 2, 3, 4, 5];

  return (
    <div className="mt-5">
      <div className="flex flex-row justify-between">
        <div className="w-[250px] h-[30px] bg-[#1a1919]"></div>
        {/* <div className="w-[100px] h-[30px] mr-[50px] bg-[#1a1919]"></div> */}
      </div>
      <div className="">
        <Swiper
          slidesPerView={6}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            350: {
              slidesPerView: 1,
            },
            500: {
              slidesPerView: 3,
            },
            1100: {
              slidesPerView: 3,
            },
            1300: {
              slidesPerView: 4,
            },
            1500: {
              slidesPerView: 4,
            },
            1700: {
              slidesPerView: 5,
            },
          }}
          className="w-full mx-auto mt-5 mb-5 mySwiper"
        >
          <div className="flex w-full gap-10 mx-auto">
            {arr.map((item: any) => (
              <div
                key={item}
                className="flex flex-col items-start justify-center"
              >
                <div className="lg:w-[320px] h-[270px] w-[320px] bg-[#1a1919] animate-pulse mt-2"></div>
              </div>
            ))}
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default CreatorVideoSkeleton;
